export interface IPaymentSettings {
  paypal: IPayPalSettings;
  adyen: IAdyenSettings;
}

export interface IPayPalSettings {
  clientId: string | null;
  expressCheckout: boolean;
}

export interface IAdyenSettings {
  clientKey: string;
  merchantAccount: string;
  applePayMerchantName: string;
  applePayMerchantId: string;
  googlePayEnvironment: string;
  googlePayMerchantName: string;
  googlePayMerchantAccountName: string;
  googlePayMerchantId: string | null;
}

export const PAYMENT_DEFAULT_SETTINGS: IPaymentSettings = {
  paypal: {
    clientId: '',
    expressCheckout: false,
  },
  adyen: {
    clientKey: '',
    merchantAccount: '',
    applePayMerchantId: '',
    applePayMerchantName: '',
    googlePayEnvironment: '',
    googlePayMerchantName: '',
    googlePayMerchantAccountName: '',
    googlePayMerchantId: '',
  },
};
